module.exports = __webpack_public_path__ + "img/logo_solo_animales.a4d05d4d.svg";